import { Icon } from "../icon";
import type { IProps } from "./dropdown-icon.types";
import { forwardRef } from "react";
import { faChevronLeft, faChevronUp } from "@fortawesome/pro-solid-svg-icons";

const DropdownIcon = forwardRef<HTMLDivElement, IProps>(function DropdownIcon(
    { isOpen, direction = "vertical", ...otherProps },
    ref
) {
    // Vertical: up when open, down when closed. Horizontal: left when open, right when closed.
    const icon = direction === "horizontal" ? faChevronLeft : faChevronUp;
    return <Icon ref={ref} size="xxs" rotation={isOpen ? undefined : 180} icon={icon} {...otherProps} />;
});

export { DropdownIcon };
